module.exports = __webpack_public_path__ + "static/media/msu-logo.7b133547.jpg";